<template>
  <div>
    <input ref="file" type="file" :id="uploadType" @click.stop @change="onFileChange">
    <label :for="uploadType" @click.stop>
      <div class="button is-primary btn-upload">
        <i class="material-icons">cloud_upload</i>{{ label }} 업로드
        <template v-if="uploadType.indexOf('file')===-1">(xlsx)</template></div>
    </label>
  </div>
</template>

<script>
  export default {
    name: "ButtonUpload",
    props: {
      uploadType: {
        type: String
      },
      label: {
        type: String
      },
      invoice: {
        type: Object
      }
    },
    created() {

    },
    data() {
      return {}
    },
    methods: {
      onFileChange(e) {
        this.$store.commit("setLoading", true);
        let files = e.target.files || e.dataTransfer.files;
        if(files.length > 0) {
          let reader = new FileReader();
          reader.readAsDataURL(files[0]);
          reader.onload = f => {
            if(this.uploadType.indexOf('file')>-1) {
              this.$axios.patch(`admin/shipagency/invoice/${this.invoice.id}`, {
                file : {
                  name: files[0].name,
                  file: f.target.result,
                  size: files[0].size
                }
              }).then(res => {
                this.$store.commit("setLoading", false);
                this.$emit('upload', res.data.file);
              }).catch(()=>{
                this.$store.commit("setLoading", false);
              });
            } else {
              this.$axios.post(`admin/shipagency/upload/${this.uploadType}`, {
                file: f.target.result
              }).then(res => {
                this.$refs.file.value = '';
                this.$store.commit("setLoading", false);
                this.toast('업로드되었습니다.');
                this.$emit('upload');
              }).catch(()=>{
                this.$refs.file.value = '';
                this.$store.commit("setLoading", false);
              });
            }
          }
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .btn-upload
    width fit-content
    display flex
    align-items center
    gap 8px
  input[type=file]
    display none
</style>
